// Checkout is no longer processed on-platform. This route now redirects the
// buyer to the order thread where they arrange payment directly with the
// seller via PayPal Goods & Services.
import { createFileRoute, Link } from "@tanstack/react-router";
import { AppShell } from "@/components/AppShell";
import { SafeTradingCard } from "@/components/SafeTradingCard";
import { MessageCircle, ArrowRight, ShieldCheck } from "lucide-react";

export const Route = createFileRoute("/_authenticated/checkout/$transactionId")({
  head: () => ({ meta: [{ title: "Contact seller — Want To Buy" }] }),
  component: CheckoutRedirectPage,
});

function CheckoutRedirectPage() {
  const { transactionId } = Route.useParams();
  return (
    <AppShell>
      <div className="mx-auto grid max-w-4xl gap-6 lg:grid-cols-[2fr_1fr]">
        <div className="panel p-6">
          <div className="flex items-center gap-2 text-primary">
            <ShieldCheck className="h-5 w-5" />
            <span className="text-[10px] font-semibold uppercase tracking-wider">
              Peer-to-peer connection platform
            </span>
          </div>
          <h1 className="mt-1 font-display text-2xl font-bold">
            Arrange payment directly with the seller
          </h1>
          <p className="mt-2 text-sm text-muted-foreground">
            Want To Buy is a directory that connects buyers and sellers — we no
            longer process on-platform payments. Message the seller to confirm
            details, then pay them directly using{" "}
            <span className="font-semibold text-foreground">PayPal Goods &amp; Services</span>.
          </p>

          <div className="mt-6 flex flex-wrap gap-2">
            <Link
              to="/orders/$id"
              params={{ id: transactionId }}
              className="btn-primary inline-flex items-center gap-2 px-4 py-2 text-sm"
            >
              <MessageCircle className="h-4 w-4" /> Contact seller
              <ArrowRight className="h-4 w-4" />
            </Link>
            <Link to="/messages" className="btn-ghost px-4 py-2 text-sm">
              Open messages
            </Link>
          </div>
        </div>

        <SafeTradingCard />
      </div>
    </AppShell>
  );
}
